/// <amd-module name="Core/Medius.Core.Web/Scripts/components/pdfViewer/pdfViewerUxLog"/>
import { trackEvent } from "../../appInsights";

export function logImagePrint(documentType: string) {
    const scenario = "Image viewer - Print";
    log(scenario, documentType);
}

export function logImageDownload(documentType: string) {
    const scenario = "Image viewer - Download";
    log(scenario, documentType);
}

export function logImageSendByEmail(documentType: string) {
    const scenario = "Image viewer - Send by email";
    log(scenario, documentType);
}

function log(scenario: string, documentType: string) {
    const s = documentType.split(".");
    documentType = documentType.split(".")[s.length - 1];

    trackEvent({
        name: "Migrated ux counter",
        properties: {
            scenario: scenario,
            documentType: documentType,
            team: "MM"
        }
    });
}